import { define } from 'wicked-elements'

const COOKIE_PROMPT_KEY = 'gpla-prompt:cookies'

function isStandalone() {
  return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
}

define('[data-component="cookie-prompt"]', {
  init() {
    if (isStandalone()) {
      this.element.remove();
      return;
    }
    if (!this.hasConsent()) {
      this.renderBanner()
    } else {
      this.element.remove()
    }
  },
  hasConsent() {
    return localStorage.getItem(COOKIE_PROMPT_KEY) === 'true'
  },
  setConsent() {
    localStorage.setItem(COOKIE_PROMPT_KEY, 'true')
  },
  renderBanner() {
    this.element.innerHTML = `
      <div class="bg-neutral-50 border border-black p-3 pt-4 flex items-center relative rounded-lg links">
        <button class="absolute top-0 right-0 p-3 text-xl leading-none" data-dismiss>&times;</button>
        <div class="message pr-8 text-lg">
          ${this.element.dataset.message}
        </div>
      </div>
    `
    this.element.querySelector('[data-dismiss]').addEventListener('click', () => this.dismissPrompt())
  },
  dismissPrompt() {
    this.setConsent()
    this.element.innerHTML = ''
    this.element.remove()
  }
})